//path: src\features\sceneName\sceneNameActions.ts

// Constants for action types
export const SET_SCAN_FILE_NAME = 'SET_SCAN_FILE_NAME';
export const SET_SCAN_UPLOADED = 'SET_SCAN_UPLOADED';

// Action Types

interface SetScanFileNameAction {
  type: typeof SET_SCAN_FILE_NAME;
  payload: { scanFileName: string };
}

interface SetScanUploadedAction {
  type: typeof SET_SCAN_UPLOADED;
  payload: { scanUploaded: boolean };
}

// Union Action Type
export type SceneNameActionTypes =
  | SetScanFileNameAction
  | SetScanUploadedAction;

// Action Creators

export const setScanFileName = (
  scanFileName: string,
): SceneNameActionTypes => ({
  type: SET_SCAN_FILE_NAME,
  payload: { scanFileName },
});

export const setScanUploaded = (uploaded: boolean): SceneNameActionTypes => ({
  type: SET_SCAN_UPLOADED,
  payload: { scanUploaded: uploaded },
});
